(function (angular, schoolwork12) {

	'use strict';
	angular.module(schoolwork12.app.k12DataManagement.name).controller(schoolwork12.app.k12DataManagement.controllers.k12DataManagement, [
		'$rootScope', '$scope', '$http', '$timeout', '$interval', '$state','$uibModal',
		schoolwork12.app.auth.services.authentication,
		schoolwork12.app.common.services.eventNotification,
		'k12DataMgmtSvc', function ($rootScope, $scope, $http, $timeout, $interval, $state, $uibModal,authentication,
			eventNotification, k12DataManagementSvc) {

			console.info("In k12dataManagement controller");
			eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
				function (event, authenticatedUser) {
					console.info('DataManagement controller: Subscribe On UserLogin Event: '
						.concat(angular.toJson(authenticatedUser)));
					// valid roles for K12 Data Management page
					$scope.mainModel.hasDataManagementRole = authentication.hasDataManagementRole();
				});

			//listen child view when saved ocurred successfully
			$scope.$parent.$on("clusterConfigSaved", function (event, flag) {
				if (flag) {
					getClusterConfigList(flag);
				}
			})

			//Listen child view when a BE service has been completed
			$scope.$parent.$on("isK12DataSaveBusy", function (event, flag) {
				$scope.isK12DataSearchBusy = flag
			})

			//Initialize global variables and functions
			$scope.setClusterConfigs = [];
			$scope.displayClusterConfigTable = false;
			$scope.isK12DataSaveBusy = false;
			$scope.isK12DataSearchBusy = false;
			$scope.clusterConfigAssociated = false;
			$scope.clusterConfigAssociatedMsg = schoolwork12.app.k12DataManagement.errorMessages.clusterConfigAssociated;

			//Initialize ClusterConfig grid 

			$scope.clusterConfgridOptions = {
				enableFiltering: true,
				enableGridMenu: true,
				exporterMenuPdf: false,
				paginationPageSizes: [25, 50, 75],
				paginationPageSize: 10,
				rowHeight: 50,
				enableRowSelection: true,
				enableRowHeaderSelection: true,
				columnDefs: [
					{ 	
						field: 'id', displayName: '#', maxWidth: 60
					},
					{
						field: 'name', displayName: 'Name', maxWidth: 500,
						cellTemplate: '<div title="Cluster Config Details" class="ui-grid-cell-contents" >' +
							'<span ng-click="grid.appScope.showClusterConfigForm(row.entity)">' +
							'<a>{{row.entity[col.field]}}</a>' +
							'</span>' +
							'</div>'
					},
					{ field: 'description', displayName: 'Description', maxWidth: 700 },
					{
						field: 'clusterConfigItems', displayName: 'Configuration Item(s) (Key:Value)', maxWidth: 500,
						cellTemplate: '<div title="Cluster Config Details" class="ui-grid-cell-contents" >' +
							'<span ng-repeat="configItem in row.entity.clusterConfigItems">'+
								'{{configItem.configKey}}:{{configItem.configValue}}' +
								'<span ng-if="$index != (row.entity.clusterConfigItems.length)-1">, </span>' +
							'</span>' +
							'</div>'
					},
					{ field: 'modifiedBy', displayName: 'Modified By', maxWidth: 150 },
					{ field: 'modifyDate', displayName: 'Modified Date', maxWidth: 150 }
				],
				onRegisterApi: function (gridApi) {
					$scope.gridApi = gridApi;
				}
			};

			// valid roles for K12 Data Management page
			$scope.mainModel = {};
			if (authentication
				&& authentication.isAuthenticated()) {
				$scope.mainModel.hasAdministratorRole = authentication
					.hasAdministratorRole();
				$scope.mainModel.hasBulkAttendanceAdjusterRole = authentication
					.hasBulkAttendanceAdjusterRole();
				$scope.mainModel.hasBulkEditAdditionRequirementRole = authentication.hasBulkEditAdditionRequirementRole();
				$scope.mainModel.hasBulkGradPlanImportRole = authentication.hasBulkGradPlanImportRole();
			};

			$scope.showClusterConfigForm = function (clusterConfig) {
				if (clusterConfig != null) {
					let tempClusterConfig = angular.copy(clusterConfig);
					$state.go('k12DataManagement.addClusterConfig', { clusterConfigObject: tempClusterConfig, operation: 'Edit' });
				} else {
					let clusterConfig = {
						"id": -1,
						"description": "",
						"name": "",
						"clusterConfigItems": [],
						"isEdited": false
					}
					// $state.go('k12DataManagement.addClusterConfig', $scope.clusterConfig);
					$state.go('k12DataManagement.addClusterConfig', { clusterConfigObject: clusterConfig, operation: 'Create' });
				}
			}

			let resetK12DataManagementPage = function () {
				$state.go('k12DataManagement');
				$scope.displayClusterConfigTable = false;
			}

			//Get Cluster Configuration List	
			$scope.getOptionsList = function () {
				resetK12DataManagementPage();
				switch ($scope.options.type) {
					case 'clusterConfig':{
						getClusterConfigList();
					}break;
					case 'systemConfig':{
						getSystemConfiguration();
					}break;
				
				}
				
			};

			let getClusterConfigList = function (afterSaved = false) {
				$scope.isK12DataSearchBusy = true;
				var clusterConfigPromise = null;
				clusterConfigPromise = k12DataManagementSvc.getClusterConfig(authentication.getCurrentUser().keycode, '/clusterConfig');
				clusterConfigPromise.then(function (data) {
					console.info("Viewing Cluster Config list grid");
					$scope.displayClusterConfigTable = true;
					$scope.setClusterConfigs = data;
					$scope.clusterConfgridOptions.data = $scope.setClusterConfigs;
					$scope.k12DataErrorOccurred = false;
					$scope.clusterConfigAssociated = false;
					$scope.k12DataSaveSuccess = afterSaved;
				}, function (error) {
					console.info('Error retrieving Cluster Config list....'.concat(angular.toJson(error)));
					$scope.k12DataErrorOccurred = true;
					$scope.k12DataErrorOccurredMsg = '';
					if (error.status == 400) {
						for (var j = 0; j < error.data._errors.length; j++) {
							$scope.k12DataErrorOccurredMsg = $scope.k12DataErrorOccurredMsg + error.data._errors[j] + "\n";
						}
					} else if (error.status == 401 || error.status == 403) {
						$scope.k12DataErrorOccurredMsg = schoolwork12.app.errorMessages.sessionExpired;
					} else {
						$scope.k12DataErrorOccurredMsg = schoolwork12.app.errorMessages.internalError;
					}

				})['finally'](function () {
					$scope.isK12DataSearchBusy = false;
				});
			}

			$scope.closek12DataSuccessSaveMsg = function () {
				$scope.k12DataSaveSuccess = false;
			}

			$scope.deleteConfigs = function (clusterConfigsToDelete) {
				let deleteConfigModal = $uibModal.open({
					animation: $scope.animationsEnabled,
					templateUrl: 'clusterConfigDeletion.html',
					windowClass: 'alert-Modal',
					keyboard: false,
					backdrop: 'static',
					controller: ['$scope', '$uibModalInstance',
						function ($scope, $uibModalInstance2) {
							//current Modal Scope
							let clusterConfigDeletionModalScope = $scope;
							clusterConfigDeletionModalScope.okDeleteClusterConfig = function () {
								$uibModalInstance2.close(true);
							};

							clusterConfigDeletionModalScope.clusterConfigDeletionMsg = "You are about to delete Cluster Configurations. Do you want to continue?";

							clusterConfigDeletionModalScope.cancelDeleteClusterConfig = function () {
								$uibModalInstance2.close(false);
							};

						}
					],
				});

				deleteConfigModal.result.then(function (deletion) {
					if (deletion) {
						$scope.isK12DataSaveBusy = true;
						clusterConfigsToDelete.forEach(element => {
							element.isEdited = true;
							element.status = 0;
						}, clusterConfigsToDelete);
						let deleteClusterConfigPromise = k12DataManagementSvc.deteleClusterConfig(authentication.getCurrentUser().keycode, clusterConfigsToDelete);
						deleteClusterConfigPromise.then(function (data) {
							if (data) {
								getClusterConfigList(true);
							}
						}, function (error) {
							console.info('Error Deleting Cluster Config list....'.concat(angular.toJson(error)));
							$scope.k12DataErrorOccurred = true;
							$scope.clusterConfigAssociated = true;
							$scope.listClusterConfigAssociated = [];
							if (error.status == 400) {
								for (var j = 0; j < error.data._errors.length; j++) {
									$scope.listClusterConfigAssociated.push(error.data._errors[j]);
								}
							} else if (error.status == 401 || error.status == 403) {
								$scope.k12DataErrorOccurredMsg = schoolwork12.app.errorMessages.sessionExpired;
							} else {
								$scope.k12DataErrorOccurredMsg = schoolwork12.app.errorMessages.internalError;
							}

						})['finally'](function () {
							$scope.isK12DataSaveBusy = false;
						});
					}
				})
			}

			$scope.deleteClusterConfigs = function () {
				let clusterConfigsToDelete = $scope.gridApi.selection.getSelectedRows();
				if (clusterConfigsToDelete.length > 0) {
					$scope.deleteConfigs(clusterConfigsToDelete);
				}
			}


			/* ------------------ System Configuration --------------------*/
			let getSystemConfiguration = function () {
				$scope.isK12DataSearchBusy = true;
				$state.go('k12DataManagement.systemConfig');
			}


		}]);

}(angular, schoolwork12));